import React from 'react';
import {
  Calendar as CalendarPicker,
  DateObject,
} from 'react-multi-date-picker';
import DatePanel from 'react-multi-date-picker/plugins/date_panel';
import { Text } from '@goodfynd/ui';
import classnames from 'clsx';

import type { CalendarProps } from './types';

export function Calendar({
  className,
  datePanelPosition = 'bottom',
  fullWidth,
  plugins,
  renderSelectedDate,
  ...props
}: CalendarProps) {
  const months = new DateObject().months.map((month) => month.name);
  const weekDays = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
  return (
    <CalendarPicker
      format="ddd, MMM DD, YYYY"
      months={months}
      weekDays={weekDays}
      className={classnames(`date-panel-${datePanelPosition}`, className, {
        'full-width': fullWidth,
      })}
      plugins={
        plugins ?? [
          <DatePanel
            key="date-panel-0"
            formatFunction={({ date, format: formattedDate }) =>
              date &&
              (renderSelectedDate?.(date.toDate()) ?? (
                <Text value={formattedDate} />
              ))
            }
          />,
        ]
      }
      {...props}
    />
  );
}
